export const getMonthLabel = (dateString: string | null | undefined, locale = "en-US") => {
  if (dateString) {
    const date = new Date(`${dateString}T00:00:00Z`);
    const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", timeZone: "UTC" };
    const formattedDate = new Intl.DateTimeFormat(locale, options).format(date);
    return formattedDate;
  }
};
